"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _TableHeader = require("./TableHeader");
var _ToolBar = require("./ToolBar");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// @ts-nocheck
// Lines 170 & 172 have incompatible type errors, resolve later.

/** A Table component that displays, sorts, and selects data. */
var Table = function Table(_ref) {
  var className = _ref.className,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    headers = _ref.headers,
    checkboxCol = _ref.checkboxCol,
    title = _ref.title,
    toolBar = _ref.toolBar;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    order = _useState2[0],
    setOrder = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    orderBy = _useState4[0],
    setOrderBy = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selected = _useState6[0],
    setSelected = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    selectAllChecked = _useState8[0],
    setSelectAllChecked = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    page = _useState10[0],
    setPage = _useState10[1];
  var _useState11 = (0, _react.useState)(5),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    rowsPerPage = _useState12[0],
    setRowsPerPage = _useState12[1];
  var sortByKey = function sortByKey(a, b, key) {
    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'desc';
    if (sort === 'asc') {
      if (b[key] < a[key]) return 1;
      if (b[key] > a[key]) return -1;
    } else if (sort === 'desc') {
      if (b[key] < a[key]) return -1;
      if (b[key] > a[key]) return 1;
    }
    return 0;
  };
  var getSorting = function getSorting(newOrder, newOrderBy) {
    return function (a, b) {
      return sortByKey(a, b, newOrderBy, newOrder);
    };
  };
  var stableSort = function stableSort(array, cmp) {
    var stabilizedThis = array.map(function (el, index) {
      return [el, index];
    });
    stabilizedThis.sort(function (a, b) {
      var newOrder = cmp(a[0], b[0]);
      if (newOrder !== 0) return newOrder;
      return Number(a[1]) - Number(b[1]);
    });
    return stabilizedThis.map(function (el) {
      return el[0];
    });
  };

  /**
   * Takes the property clicked on and toggles sorting order (asc/desc).
   * @param {Object} e Synthetic event
   * @param {String} property The column to sort on
   */
  var handleRequestSort = function handleRequestSort(e, property) {
    var newOrderBy = property;
    var newOrder = order === 'desc' && newOrderBy === property ? 'asc' : 'desc';
    setOrder(newOrder);
    setOrderBy(newOrderBy);
  };

  /**
   * Toggles the select all checkbox and adds/removes all rows.
   * @param {Object} e Synthetic event
   */
  var handleSelectAllClick = function handleSelectAllClick() {
    if (!selectAllChecked) {
      setSelected(data);
      setSelectAllChecked(!selectAllChecked);
      return;
    }
    setSelected([]);
    setSelectAllChecked(!selectAllChecked);
  };

  /**
   * Toggles checkbox on clicked row.
   * @param {Object} e Synthetic event
   * @param {Object} row Object containing cell data
   */
  var handleClick = function handleClick(e, row) {
    var selectedIndex = selected.indexOf(row);
    var newSelected;
    newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  /**
   * Changes page of table.
   * @param {Object} e Synthetic event
   * @param {Number} page Page number
   */
  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
  };

  /**
   * Changes rows shown per page.
   * @param {Object} e Synthetic event
   */
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(Number(event.target.value));
  };

  /**
   * Changes rows shown per page.
   * @param {Object} id Selected row
   */
  var isSelected = function isSelected(id) {
    return selected.indexOf(id) !== -1;
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: "".concat(className, " root")
  }, toolBar && /*#__PURE__*/_react["default"].createElement(_ToolBar.ToolBar, {
    numSelected: selected && selected.length,
    title: title,
    count: data && data.length
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " tableWrapper")
  }, /*#__PURE__*/_react["default"].createElement(_core.Table, {
    className: "".concat(className, " table"),
    "aria-labelledby": "tableTitle"
  }, /*#__PURE__*/_react["default"].createElement(_TableHeader.TableHeader, {
    checkboxCol: checkboxCol,
    headers: headers,
    numSelected: selected.length,
    order: order || 'asc',
    orderBy: orderBy,
    onSelectAllClick: handleSelectAllClick,
    onRequestSort: handleRequestSort,
    rowCount: data && data.length
  }), /*#__PURE__*/_react["default"].createElement(_core.TableBody, null, stableSort(data, getSorting(order || 'asc', orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (n, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.TableRow, {
      hover: true,
      onClick: function onClick(e) {
        return handleClick(e, n);
      },
      role: "checkbox",
      "aria-checked": isSelected(n),
      tabIndex: -1,
      key: i,
      selected: isSelected(n)
    }, checkboxCol && /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: isSelected(n)
    })), Object.keys(n).map(function (key, index) {
      return index === 0 ? /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
        key: index,
        component: "th",
        scope: "row",
        padding: checkboxCol ? 'none' : 'default'
      }, n[key]) : /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
        key: index
      }, n[key]);
    }));
  })))), /*#__PURE__*/_react["default"].createElement(_core.TablePagination, {
    rowsPerPageOptions: [5, 10, 25],
    component: "div",
    count: data ? data.length : 0,
    rowsPerPage: rowsPerPage,
    page: page,
    backIconButtonProps: {
      'aria-label': 'Previous Page'
    },
    nextIconButtonProps: {
      'aria-label': 'Next Page'
    },
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};
exports.Table = Table;